import axios from "axios";

// Use environment variable for API URL, with a fallback
const MESSAGE_NOTIFICATION_API_URL =
  import.meta.env.VITE_MESSAGE_NOTIFICATION_API_URL ||
  (window.location.hostname === "localhost"
    ? `${window.location.protocol}//${window.location.hostname}:8000/api/message-notifications`
    : "/api/message-notifications");

// Helper function to get headers with token
const getAuthHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token =
    localStorage.getItem("adminToken") ||
    localStorage.getItem("staffToken") ||
    localStorage.getItem("customerToken") ||
    localStorage.getItem("bankingPartnerToken") ||
    localStorage.getItem("affiliatePartnerToken") ||
    localStorage.getItem("creditManagerToken") ||
    localStorage.getItem("token");

  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }
  return headers;
};

// API functions
export const getMessageNotifications = async (
  page = 1,
  limit = 20,
  unreadOnly = false
) => {
  try {
    const response = await axios.get(`${MESSAGE_NOTIFICATION_API_URL}`, {
      headers: getAuthHeaders(),
      params: { page, limit, unreadOnly },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching message notifications:", error);
    throw error;
  }
};

export const getUnreadMessageNotificationCount = async () => {
  try {
    const response = await axios.get(
      `${MESSAGE_NOTIFICATION_API_URL}/unread-count`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching unread message notification count:", error);
    throw error;
  }
};

export const markMessageNotificationAsRead = async (notificationId) => {
  try {
    const response = await axios.put(
      `${MESSAGE_NOTIFICATION_API_URL}/mark-read/${notificationId}`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking message notification as read:", error);
    throw error;
  }
};

export const markAllMessageNotificationsAsRead = async () => {
  try {
    const response = await axios.put(
      `${MESSAGE_NOTIFICATION_API_URL}/mark-all-read`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    console.error("Error marking all message notifications as read:", error);
    throw error;
  }
};

export const deleteMessageNotification = async (notificationId) => {
  try {
    const response = await axios.delete(
      `${MESSAGE_NOTIFICATION_API_URL}/${notificationId}`,
      {
        headers: getAuthHeaders(),
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error deleting message notification:", error);
    throw error;
  }
};

export const deleteAllMessageNotifications = async () => {
  try {
    const response = await axios.delete(`${MESSAGE_NOTIFICATION_API_URL}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting all message notifications:", error);
    throw error;
  }
};
